import React, { useState, useEffect } from 'react'
import { Row } from 'react-bootstrap'
import ReactPaginate from 'react-paginate'
import {
  nextPaginationArrow,
  prevPaginationArrow,
  productsList
} from '../SvgPaths/SvgPaths'
import { useNavigate } from 'react-router-dom'
import wishlistSelectedIcon from '../../assets/images/png/wishlistSelectedIcon.png'
import Clock from '../../assets/images/png/green-clock-icon.png'
import Location from '../../assets/images/png/location-icon.png'
import Tag from '../../assets/images/png/tag-icon.png'
import {
  addProducttoWishlist,
  getWishlistProducts
} from '../../services/WishlistServices'
import arrowback from '../../assets/images/png/arrow_back.png'

const Wishlist = () => {
  const navigate = useNavigate()

  const [pageNumber, setPageNumber] = useState(0)
  const [productsToBeShown, setProductsToBeShown] = useState(12)
  const [favouriteItems, setFavouriteItems] = useState([])
  const [totalPages, setTotalPages] = useState(0)

  const getfav = async () => {
    const tokenitem = localStorage.getItem('token')

    const totalCountRes = await getWishlistProducts(tokenitem)
    const totalCount = totalCountRes ? totalCountRes.length : 0

    const res = await getWishlistProducts(
      tokenitem,
      pageNumber,
      productsToBeShown
    )
    if (res) {
      setFavouriteItems(res)
      setTotalPages(Math.ceil(totalCount / productsToBeShown))
    }
  }

  useEffect(() => {
    getfav()
  }, [])

  useEffect(() => {
    getfav()
  }, [productsToBeShown, pageNumber])

  const removefromwishlist = async id => {
    const tokenitem = localStorage.getItem('token')
    const productId = id
    await addProducttoWishlist(productId, tokenitem)
    getfav()
  }
  const handlePageChange = ({ selected }) => {
    setPageNumber(selected + 1)
  }

  return (
    <div className='bg_clr_light_yellow py-5'>
      <div className='container px-sm-5 px-2'>
        <div className='d-flex align-items-center justify-content-between'>
          <div className='d-flex align-items-center gap-1'>
            <p className='mb-0 fw-medium clr_dark_grey_2 fs_2xsm'>SHOW:</p>
            <input
              className='product-number-input'
              value={productsToBeShown}
              onChange={e => {
                const inputValue = parseInt(e.target.value)
                if (inputValue < 6) {
                  setProductsToBeShown(6)
                } else {
                  setProductsToBeShown(inputValue)
                }
              }}
              type='number'
            />
          </div>
          <div>
            <span className='fw-medium ff_heebo fs_2xsm clr_dark_grey_2'>
              SORT BY :{' '}
              <input
                placeholder='Default'
                className='custom_default_input'
                type='number'
              />
            </span>
          </div>
        </div>
        <div className='overflow-x-hidden'>
          <Row
            style={{ borderRadius: '12px' }}
            className='bg-white px-3 py-5 mt-5 mx-2'
          >
            {favouriteItems && favouriteItems.length !== 0 ? (
              <>
                {favouriteItems &&
                  favouriteItems?.map((item, index) => (
                    <div className='col-lg-3 col-md-4 col-sm-6' key={index}>
                      <div className='bg-hover cursor_pointer bg-light-green position-relative products-card rounded-2 pb-3 h-100'>
                        <div className='d-flex flex-column justify-content-between h-100'>
                          <div
                            onClick={() =>
                              item?.productId?.productType === 'seed' ||
                              item?.productId?.productType === 'gaonSe' ||
                              item?.productId?.productType === 'innovative'
                                ? navigate(
                                    `/product-details/${item?.productId?._id}`
                                  )
                                : navigate(`/all-product`)
                            }
                          >
                            {item?.productId?.productType === 'seed' ||
                            item?.productId?.productType === 'gaonSe' ||
                            item?.productId?.productType === 'innovative' ? (
                              item?.productId?.discountPrice &&
                              item?.productId?.price && (
                                <span className='mb-0 bg_clr_yellow text-white px-3 py-1 rounded-2 ff_heebo fs_3xsm position-absolute discount-percentage-wishlist'>
                                  {Math.round(
                                    ((item?.productId?.price -
                                      item?.productId?.discountPrice) /
                                      item?.productId?.price) *
                                      100
                                  )}
                                  % Off
                                </span>
                              )
                            ) : (
                              <span
                                className={`position-absolute top-0 end-0 mt-2 text-white py-1 px-3 rounded-2 me-2 fs_3xsm ${
                                  item?.productId?.adType === 'sales'
                                    ? 'bg_red'
                                    : item?.adType === 'lease'
                                    ? 'bg-purple'
                                    : 'bg_clr_green'
                                } ff_heebo fs_3xsm text-capitalize`}
                              >
                                {item?.productId?.adType}
                              </span>
                            )}
                            <div className='bg-white'>
                              <div
                                className={`text-center mx-auto ${
                                  item?.productId?.productType === 'seed'
                                    ? 'product-seed pt-3'
                                    : ''
                                }`}
                              >
                                <img
                                  style={{ borderRadius: '8px 8px 0 0' }}
                                  className={`object-fit-cover ${
                                    item?.productId?.productType === 'seed'
                                      ? 'w-100'
                                      : 'product-machinery'
                                  }`}
                                  src={item?.productId?.images?.[0]}
                                  alt=''
                                />
                              </div>
                            </div>
                            {item?.productId?.productType === 'machinery' ? (
                              <div className=' px-3'>
                                <div className='d-flex align-items-center pt-2'>
                                  <img src={Tag} alt='tag' />{' '}
                                  <span className='clr_dark_green ff_heebo fs_3xsm ms-3'>
                                    Threshur / Agri Equipments
                                  </span>
                                </div>
                                <div className='hr-line mt-2'></div>
                              </div>
                            ) : (
                              ''
                            )}
                            <div className='px-3'>
                              <p className='ff_heebo fw-medium fs_md clr_dark_blue pe-2 mt-2 mb-0 text-capitalize'>
                                {item?.productId?.name}
                              </p>
                              {item?.productId?.productType === 'seed' ||
                              item?.productId?.productType === 'gaonSe' ||
                              item?.productId?.productType === 'innovative' ? (
                                <div className='hr-line'></div>
                              ) : (
                                ''
                              )}
                              {item?.productId?.productType === 'machinery' ? (
                                <div className='d-flex align-items-center mt-3'>
                                  <div>
                                    <img
                                      className='mb-10'
                                      src={Location}
                                      alt='tag'
                                    />
                                  </div>{' '}
                                  <span className='clr_dark_green ff_heebo fs_3xsm ms-1'>
                                    {item?.productId?.location}
                                  </span>
                                  <div className='ms-3'>
                                    {' '}
                                    <img
                                      className='mb-10'
                                      src={Clock}
                                      alt='tag'
                                    />
                                  </div>{' '}
                                  <span className='clr_dark_green ff_heebo fs_3xsm ms-1'>
                                    30 min ago
                                  </span>
                                </div>
                              ) : (
                                <p className='ff_heebo mb-0 fs_xxsm mt-2'>
                                  {item?.productId?.description
                                    ?.replace(/<\/?[^>]+(>|$)/g, '')
                                    .split(' ')
                                    .slice(0, 15)
                                    .join(' ')}
                                </p>
                              )}
                            </div>
                          </div>
                          <div className='px-3'>
                            <div className='hr-line mt-3'></div>

                            <div className='row align-items-center justify-content-between mt-2'>
                              <div
                                onClick={() =>
                                  item?.productId?.productType === 'seed' ||
                                  item?.productId?.productType === 'gaonSe' ||
                                  item?.productId?.productType === 'innovative'
                                    ? navigate(
                                        `/product-details/${item?.productId?._id}`
                                      )
                                    : navigate(`/all-product`)
                                }
                                className='col-10 pe-0'
                              >
                                <div className=' d-flex align-items-center justify-content-between'>
                                  <p className='ff_arial fw-bold fs_md mb-0 text-black'>
                                    {item?.productId?.discountPrice}
                                    <span className='fs_4xsm fw-normal clr_dark_green'>
                                      /
                                      {item?.productId?.productType ===
                                        'seed' ||
                                      item?.productId?.productType ===
                                        'gaonSe' ||
                                      item?.productId?.productType ===
                                        'innovative' ? (
                                        <span className='text-decoration-line-through'>
                                          ₹ {item?.productId?.price}
                                        </span>
                                      ) : (
                                        <span>
                                          {' '}
                                          {item?.productId?.priceType}
                                        </span>
                                      )}
                                    </span>
                                  </p>
                                </div>
                              </div>
                              <div className='col-2 ps-0'>
                                <div className='d-flex align-items-center justify-content-end gap-3'>
                                  <div
                                    onClick={() =>
                                      item?.productId?.productType === 'seed' ||
                                      item?.productId?.productType ===
                                        'gaonSe' ||
                                      item?.productId?.productType ===
                                        'innovative'
                                        ? navigate(
                                            `/product-details/${item?.productId?._id}`
                                          )
                                        : navigate(`/all-product`)
                                    }
                                    className='vr-line'
                                  ></div>
                                  <div
                                    onClick={() => {
                                      removefromwishlist(item?.productId?._id)
                                    }}
                                  >
                                    <img
                                      className='postion-relative z-3'
                                      width={18}
                                      src={wishlistSelectedIcon}
                                      alt='wishlistIcon'
                                    />
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  ))}
              </>
            ) : (
              <div className='py-5'>
                <h2 className='text-center'>No Product found</h2>
                <div className='d-flex flex-column flex-sm-row align-items-center justify-content-center gap-sm-5 gap-1'>
                  <button
                    onClick={() => navigate('/farmer-shop')}
                    className='d-flex align-items-center gap-2 justify-content-center mt-3 btn-common-remove-save py-2 px-3'
                  >
                    <img
                      style={{ width: '18px', height1: '18px' }}
                      src={arrowback}
                      alt='backarrow'
                    />
                    <p className='mb-0 clr_dark_green fw-medium'>
                      Add Products
                    </p>
                  </button>
                </div>
              </div>
            )}
          </Row>

          <div className='d-flex flex-column flex-sm-row gap-3 mt-4 align-items-center justify-content-between'>
            <p className='mb-0 ff_heebo fw-medium fs_xsm clr_dark_grey_3'>
              Showing {productsToBeShown} - {favouriteItems.length} of{' '}
              {favouriteItems.length} results
            </p>
            <div className='pagination-container'>
              <ReactPaginate
                previousLabel={prevPaginationArrow}
                nextLabel={nextPaginationArrow}
                pageCount={totalPages > 0 ? totalPages : 1}
                onPageChange={handlePageChange}
                containerClassName={'pagination justify-content-end mb-0'}
                previousLinkClassName={'pagination__link'}
                nextLinkClassName={'pagination__link'}
                pageClassName={
                  'pagination__page d-flex align-items-center justify-content-center clr_dark_grey_3 mx-1 ff_heebo fw-medium fs_xsm'
                }
                disabledClassName={'pagination__link--disabled'}
                activeClassName={
                  'pagination__link--active d-flex align-items-center justify-content-center text-white ff_heebo fw-medium fs_xsm'
                }
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

export default Wishlist
